/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './live-featured-event.stache';
import can from 'can';
import liveVideoService from 'scripts/services/live-video-service';
import { showLiveVideoModal } from 'components/live-video-modal/live-video-modal';
import appContext from 'scripts/app-context';

const inWebView = window.globalSettings.inWebView;

Component.extend({
    tag: 'live-featured-event',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            featuredEvent: {
                Type: can.Map,
                Value: null,
            },
            isMobileWeb: {
                type: 'boolean',
                get() {
                    return (
                        ['small', 'extra-small'].indexOf(
                            appContext.model.screen.attr('screenSize'),
                        ) > -1 && !inWebView
                    );
                },
            },
            isActive: {
                type: 'boolean',
                value: false,
            },
            playerTags: {
                type: 'string',
                get() {
                    const playerTags =
                        this.attr('featuredEvent.playerTagGroups') || [];
                    return playerTags
                        .map((groupTag) =>
                            groupTag
                                .map((playerTag) => playerTag.title)
                                .join(', '),
                        )
                        .join(', ');
                },
            },
        },
        closeLiveVideoPlayer() {
            this.attr('isActive', false);
        },
        onVideoClick(event, videoId) {
            event.preventDefault();

            if (this.attr('isMobileWeb')) {
                showLiveVideoModal();
            } else {
                liveVideoService.openWindow(videoId);
                this.attr('isActive', true);
            }
        },
    },
});
